import store2 from 'store2'
import { parseISO, differenceInWeeks, differenceInHours } from 'date-fns'
import { STORAGE_KEY } from './pe-nps-feedback'

export const VISIT_COUNT_KEY = 'nps-visit-count'
export const LAST_COUNT_DATE = 'nps-last-visit-date'
const ASK_LATER_WEEKS = 1

export function countVisit () {
  const lastCount = store2.get(LAST_COUNT_DATE)
  // Only count if last visit was 24hrs ago
  if (lastCount && differenceInHours(new Date(), parseISO(lastCount)) < 24) return
  store2.add(VISIT_COUNT_KEY, 1)
  store2.set(LAST_COUNT_DATE, new Date())
}

export function visitCount () {
  return parseInt(store2.get(VISIT_COUNT_KEY) || 0, 10) + 1 // 0 based -> 1 based
}

export function weeksSince (isoDate) {
  return differenceInWeeks(new Date(), parseISO(isoDate))
}

export function completedOrDelayed () {
  const lastAction = store2.get(STORAGE_KEY)
  if (lastAction?.action === 'feedback') return true
  if (lastAction?.action === 'later' && weeksSince(lastAction.when) < ASK_LATER_WEEKS) return true
  return false
}
